/**
 * Keeps the category pills in step with the address.
 *
 * Filtering re-renders the product grid through the facets component, and that
 * pass does not include the section this block sits in - so the state Liquid
 * printed goes stale: clearing the filters left the pill highlighted. Both the
 * highlight and each link are therefore derived from the current URL rather than
 * from what was rendered.
 */
const PILL = '.category-links__pill';
const SELECTED = 'category-links__pill--selected';

function sync() {
  const pills = document.querySelectorAll(PILL);
  if (!pills.length) return;

  for (const pill of pills) {
    const { param, value } = pill.dataset;
    if (!param || !value) continue;

    const url = new URL(window.location.href);
    const current = url.searchParams.getAll(param);
    const active = current.includes(value);

    pill.classList.toggle(SELECTED, active);
    if (active) {
      pill.setAttribute('aria-current', 'true');
    } else {
      pill.removeAttribute('aria-current');
    }

    // the link is built from the live address, so other filters the visitor has
    // already picked survive the click
    const next = new URL(window.location.href);
    next.searchParams.delete('page');
    next.searchParams.delete(param);
    for (const kept of current) {
      if (kept !== value) next.searchParams.append(param, kept);
    }
    if (!active) next.searchParams.append(param, value);
    pill.href = `${next.pathname}${next.search}`;
  }
}

let lastUrl = window.location.href;
let frame = null;

function syncIfMoved() {
  if (window.location.href === lastUrl) return;
  lastUrl = window.location.href;
  if (frame) cancelAnimationFrame(frame);
  frame = requestAnimationFrame(() => {
    frame = null;
    sync();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', sync, { once: true });
} else {
  sync();
}

window.addEventListener('popstate', sync);
// the facets component swaps the grid and rewrites the address without a reload
new MutationObserver(syncIfMoved).observe(document.documentElement, { childList: true, subtree: true });
